import { park1hQuery, lightningQuery, catchErrorsV2 } from '../ReportsAPI';
import { getSelectedItems } from 'common/state.helper';
import { NO_DATA_VALUE } from 'lib/components/_charts/Chart.utils';

const defaultState = {
    totalGenerationData: [],
    windSpeedData: [],
    observedLightningData: [],
    forecastWaveHeightData: [],
};

const totalGenerationChart = {
    name: 'totalGenerationChart',
    state: defaultState,

    reducers: {
        setChartData(state, payload) {
            return {
                ...state,
                ...payload,
            };
        },
    },

    effects: (dispatch) => ({
        loadAll() {
            catchErrorsV2(
                () => dispatch.totalGenerationChart.queryData(),
                () => dispatch.totalGenerationChart.setChartData(defaultState)
            );
        },

        async queryData(_, state) {
            const { selectedDate, selectedParkId } = getSelectedItems(state);

            const { data = [] } = await park1hQuery(selectedDate, selectedParkId);
            const lightning = await lightningQuery(selectedDate, selectedParkId);
            const totalGenerationData = [];
            const windSpeedData = [];
            const forecastWaveHeightData = [];
            const observedLightningData = [];

            data.forEach((item) => {
                const { wave_height, wind_speed, total_generation, ts: time } = item;

                totalGenerationData.push({
                    value: total_generation || NO_DATA_VALUE,
                    key: time,
                });
                windSpeedData.push({
                    value: wind_speed || NO_DATA_VALUE,
                    key: time,
                });
                forecastWaveHeightData.push({
                    value: wave_height || NO_DATA_VALUE,
                    key: time,
                });
            });

            lightning.data.forEach((item) => {
                const { ts: time } = item;

                observedLightningData.push({
                    key: time,
                });
            });

            dispatch.totalGenerationChart.setChartData({
                totalGenerationData,
                windSpeedData,
                observedLightningData,
                forecastWaveHeightData,
            });
        },
    }),
};

export default totalGenerationChart;
